(function() {
    function getFrame(event) {
        const frames = document.getElementsByTagName('iframe');

        for (const frame of frames) {
            if (frame.contentWindow === event.source) {
                return frame;
            }
        }
    }

    const templateElements = {
        cube: 'blox-ad-gam-creative-cube',
        parallax: 'blox-ad-gam-creative-parallax',
        reveal: 'blox-ad-gam-creative-reveal',
        roller: 'blox-ad-gam-creative-roller',
        slider: 'blox-ad-gam-creative-slider',
        sticky_anchor: 'blox-ad-gam-creative-sticky-anchor'
    };

    window.addEventListener('message', function(event) {
        if (!event.origin.endsWith('.safeframe.googlesyndication.com') && event.origin !== window.location.origin) return;
        if (!event.data || typeof event.data !== 'object') return;

        if (event.data.type === 'BLOX_AD') {
            if (!Object.keys(templateElements).includes(event.data.template)) return;

            const template = event.data.template;
            const frame = getFrame(event);
            const block = frame.closest('blox-block');
            const component = document.createElement(templateElements[template]);
            const jsonConfig = document.createElement('script');
            jsonConfig.setAttribute('type', 'application/json');
            jsonConfig.textContent = JSON.stringify(event.data.options);
            component.append(jsonConfig);

            if (template === 'reveal') {
                const siteContainer = document.getElementById('site-container');
                if (siteContainer) {
                    siteContainer.before(component);
                }

            } else {
                block.append(component);
            }
        }
    });
})();